import React from 'react';
import {Form} from 'react-form';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import {FormGroup, Text, SelectCreatable, Checkbox} from 'components/FormElements/';
import ServiceService from 'services/ServiceService';
import {toggleLoading, toggleAlertError} from 'stores/actions/';
import {required} from 'constants/InputErrors';

class ServiceEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    if( this.entityId ) this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    ServiceService.getService( this.entityId ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ) this.setState( { data: response.data } )
    } )
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );
    const promise = this.entityId ? ServiceService.updateService( this.entityId, data ) :
      ServiceService.saveService( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );
      return history.push( '/configurations/services' )
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{this.entityId ? <Translate id="edit"/> : <Translate id="new"/>} <Translate id="service"/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                service: required( values.service )
              }
            }}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="name"/></label>
                    <Text field="service" className="form-control"/>
                  </FormGroup>
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="externalCode"/></label>
                    <Text field="codExt" className="form-control"/>
                  </FormGroup>
                </div>

                <FormGroup containerClass="col-md-2 pl-0">
                  <Checkbox field="active" label={<Translate id="active"/>}/>
                </FormGroup>

                <div className="text-right mt-4">
                  <Link to={`/configurations/services`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( ServiceEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/services/edit/index.js